/* MaxLife Assessment (tiered) — assets/maxlife-assessment.js
   Goal picks the protocol line; budget picks the tier (starter / core / complete).
   Links come from data-link-<goal>-<tier> attributes on the section. If a tier link
   is blank it falls back to the tier below it, so Calm/Sleep can launch with 2 tiers. */
(function () {
  function init(root) {
    if (!root || root.dataset.mxInit) return;
    root.dataset.mxInit = '1';
    var stage = root.querySelector('[data-stage]'), bar = root.querySelector('[data-bar]');
    var WEBHOOK = root.getAttribute('data-webhook') || null;
    var CODE = root.getAttribute('data-code') || 'WELCOME20';

    function link(goal, tier) {
      var order = { complete: ['complete','core','starter'], core: ['core','starter'], starter: ['starter'] }[tier];
      for (var i = 0; i < order.length; i++) {
        var v = root.getAttribute('data-link-' + goal + '-' + order[i]);
        if (v) return v;
      }
      return '/collections/all';
    }

    var questions = [
      { key:'age', label:'Question 1 of 4', q:'What is your age range?', opts:[
        {v:'under-35',t:'Under 35'},{v:'35-44',t:'35\u201344'},{v:'45-54',t:'45\u201354'},{v:'55-plus',t:'55+'} ]},
      { key:'goal', label:'Question 2 of 4', q:'What matters most to you right now?', opts:[
        {v:'renewal',t:'Healthy aging & cellular renewal',s:'Support NAD+ levels and the body\u2019s renewal processes'},
        {v:'energy',t:'Daily energy & vitality',s:'Support cellular energy metabolism'},
        {v:'focus',t:'Focus & mental clarity',s:'Steady energy and a clear head'},
        {v:'calm',t:'Everyday calm & stress support',s:'Non-drowsy calm through the day'},
        {v:'sleep',t:'Restful sleep',s:'Wind down and sleep better'},
        {v:'complete',t:'A comprehensive approach',s:'I want the full protocol'} ]},
      { key:'use', label:'Question 3 of 4', q:'Where are you starting from?', opts:[
        {v:'new',t:'New to this',s:'This would be my first protocol'},
        {v:'basics',t:'Just the basics',s:'Multivitamin, fish oil, vitamin D'},
        {v:'some',t:'A few targeted ones',s:'NMN, resveratrol, or similar'},
        {v:'full',t:'A full routine',s:'I follow a structured protocol'} ]},
      { key:'budget', label:'Question 4 of 4', q:'What monthly budget feels right?', opts:[
        {v:'starter',t:'Around $50',s:'A focused two-product start'},
        {v:'core',t:'$50\u2013$100',s:'A three-product protocol'},
        {v:'complete',t:'$100+',s:'The complete protocol'} ]}
    ];

    var protocols = {
      renewal: {
        starter:  { name:'Renewal Starter', includes:'Liposomal NAD+ \u00b7 NMN', desc:'The two compounds at the center of cellular aging research, together. Helps maintain NAD+ levels that naturally decline with age.*' },
        core:     { name:'Renewal Protocol', includes:'Liposomal NAD+ \u00b7 NMN \u00b7 S-Acetyl Glutathione', desc:'NAD+ support plus intracellular antioxidant support \u2014 energy pathways and cellular defense in one routine.*' },
        complete: { name:'Complete Renewal Protocol', includes:'Liposomal NAD+ \u00b7 NMN \u00b7 S-Acetyl Glutathione \u00b7 Spermidine', desc:'Our most comprehensive rejuvenation stack: NAD+ support, antioxidant defense, and spermidine for the body\u2019s own cellular renewal processes.*' }
      },
      energy: {
        starter:  { name:'Energy Starter', includes:'Liposomal NMNH \u00b7 TTFD-B1 Max', desc:'Two formulas built around cellular energy metabolism \u2014 an ultra-absorbable NAD+ precursor and an advanced form of vitamin B1.*' },
        core:     { name:'Energy Protocol', includes:'Liposomal NMNH \u00b7 TTFD-B1 Max \u00b7 Liposomal NAD+', desc:'The energy pathway, supported from three angles: precursor, cofactor, and NAD+ itself.*' },
        complete: { name:'Complete Energy Protocol', includes:'Liposomal NMNH \u00b7 TTFD-B1 Max \u00b7 Liposomal NAD+ \u00b7 NMN', desc:'The full cellular energy stack for steady, all-day vitality.*' }
      },
      focus: {
        starter:  { name:'Focus Starter', includes:'Methyl Blue+ \u00b7 TTFD-B1 Max', desc:'Formulas that support mitochondrial function and energy metabolism for a clear, steady head.*' },
        core:     { name:'Focus Protocol', includes:'Methyl Blue+ \u00b7 TTFD-B1 Max \u00b7 Magnesium L-Threonate', desc:'Adds the form of magnesium studied for brain support \u2014 focus by day, better rest by night.*' },
        complete: { name:'Complete Focus Protocol', includes:'Methyl Blue+ \u00b7 TTFD-B1 Max \u00b7 Magnesium L-Threonate \u00b7 Liposomal NMNH', desc:'The full clarity stack: mitochondrial support, B1, brain-support magnesium, and an NAD+ precursor.*' }
      },
      calm: {
        starter:  { name:'Calm Starter', includes:'Day Chill\u2122 \u00b7 Night Chill\u2122', desc:'DHH-B from Magnolia bark \u2014 calm, relaxed focus by day and wind-down support by night.*' },
        core:     { name:'Calm Protocol', includes:'Day Chill\u2122 \u00b7 Night Chill\u2122 \u00b7 Magnesium L-Threonate', desc:'The day-and-night routine plus magnesium for relaxation and restful sleep.*' },
        complete: null
      },
      sleep: {
        starter:  { name:'Rest Starter', includes:'Night Chill\u2122 \u00b7 Magnesium L-Threonate', desc:'Wind-down support and a form of magnesium that supports restful, natural sleep.*' },
        core:     { name:'Rest Protocol', includes:'Day Chill\u2122 \u00b7 Night Chill\u2122 \u00b7 Magnesium L-Threonate', desc:'Steady calm through the day sets up better rest at night.*' },
        complete: null
      }
    };

    var answers = {}, step = 0, total = questions.length + 1;
    function setBar() { bar.style.width = Math.round(step / total * 100) + '%'; }
    function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

    function pick() {
      var goal = answers.goal === 'complete' ? 'renewal' : answers.goal;
      var tier = answers.goal === 'complete' ? 'complete' : (answers.budget || 'starter');
      var p = protocols[goal];
      // fall back down the tiers if a goal doesn't have that tier yet
      if (!p[tier]) tier = p.core ? 'core' : 'starter';
      return { goal: goal, tier: tier, proto: p[tier] };
    }

    function renderQ() {
      var it = questions[step];
      stage.innerHTML = '';
      stage.appendChild(el('div', 'mx-step', it.label));
      stage.appendChild(el('h2', null, it.q));
      it.opts.forEach(function (o) {
        var b = el('button', 'mx-opt', o.t); b.type = 'button';
        if (o.s) b.appendChild(el('small', null, o.s));
        b.addEventListener('click', function () {
          answers[it.key] = o.v; step++; setBar();
          step < questions.length ? renderQ() : renderEmail();
        });
        stage.appendChild(b);
      });
      var first = stage.querySelector('.mx-opt'); if (first) first.focus();
    }

    function renderEmail() {
      stage.innerHTML = '';
      stage.appendChild(el('div', 'mx-step', 'One last step'));
      stage.appendChild(el('h2', null, 'Your protocol is ready.'));
      stage.appendChild(el('p', 'mx-sub', 'Enter your email to see your personalized protocol, plus a code for 20% off your first order.'));
      var err = el('div', 'mx-err', 'Please enter a valid email.'); stage.appendChild(err);
      var email = el('input', 'mx-email'); email.type = 'email'; email.autocomplete = 'email'; email.placeholder = 'you@email.com'; stage.appendChild(email);
      var wrap = el('div'); var btn = el('button', 'mx-btn mx-btn--slate', 'Show my protocol'); btn.type = 'button'; wrap.appendChild(btn); stage.appendChild(wrap);
      stage.appendChild(el('div', 'mx-fine', 'We\u2019ll send your results and occasional research updates. Unsubscribe anytime.'));
      email.focus();
      function go() {
        var v = email.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { err.style.display = 'block'; return; }
        err.style.display = 'none'; btn.disabled = true; btn.textContent = 'Building your protocol\u2026';
        var r = pick();
        var payload = { email: v, age_range: answers.age, goal: answers.goal, current_use: answers.use, budget: answers.budget, recommended_stack: r.goal + '_' + r.tier, source_page: location.pathname };
        var done = function () { step = total; setBar(); renderResult(r); };
        if (WEBHOOK) {
          fetch(WEBHOOK, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).then(done).catch(done);
        } else { setTimeout(done, 400); }
      }
      btn.addEventListener('click', go);
      email.addEventListener('keydown', function (e) { if (e.key === 'Enter') go(); });
    }

    function renderResult(r) {
      var p = r.proto;
      stage.innerHTML = '';
      var card = el('div', 'mx-result');
      card.appendChild(el('div', 'mx-step', 'Your recommendation'));
      card.appendChild(el('h2', null, p.name));
      var inc = el('div', 'mx-includes'); inc.appendChild(el('span', 'mx-includes-label', 'Includes ')); inc.appendChild(document.createTextNode(p.includes)); card.appendChild(inc);
      card.appendChild(el('p', null, p.desc));
      var a = el('a', 'mx-btn mx-btn--ice', 'Get this protocol \u2192'); a.href = link(r.goal, r.tier); card.appendChild(a);
      var code = el('div', 'mx-code'); code.appendChild(document.createTextNode('Use code ')); code.appendChild(el('b', null, CODE)); code.appendChild(document.createTextNode(' for 20% off your first order.')); card.appendChild(code);
      stage.appendChild(card);
      var fine = el('div', 'mx-fine', '*These statements have not been evaluated by the FDA. These products are not intended to diagnose, treat, cure, or prevent any disease.');
      fine.style.textAlign = 'center'; fine.style.marginTop = '18px'; stage.appendChild(fine);
    }

    setBar(); renderQ();
  }

  function initAll() { document.querySelectorAll('[data-mx-assessment]').forEach(init); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
